<template>
  <div class="google-map"></div>
</template>

<script>
import gmapsInit from "@/utils/gmaps";
import { mapState } from "vuex";

// https://stackoverflow.com/questions/3410600/convert-lat-lon-to-pixels-and-back
// const pixel = (map, latLng) => {
//   console.log('map', map);
//   console.log('latLng', latLng);
//   const projection = map.getProjection();
//   const bounds = map.getBounds();
//   const topRight = projection.fromLatLngToPoint(bounds.getNorthEast());
//   const bottomLeft = projection.fromLatLngToPoint(bounds.getSouthWest());
//   const scale = Math.pow(2, map.getZoom());
//   const worldPoint = projection.fromLatLngToPoint(latLng);
//   return {
//     x: Math.floor((worldPoint.x - bottomLeft.x) * scale),
//     y: Math.floor((worldPoint.y - topRight.y) * scale)
//   };
// };

export default {
  name: "GoogleMap",

  data() {
    return {
      map: {},
      latLng: {}
    };
  },

  computed: {
    ...mapState(["pin"])
  },

  methods: {
    // https://stackoverflow.com/questions/3410600/convert-lat-lon-to-pixels-and-back
    setPin() {
      const projection = this.map.getProjection();
      const bounds = this.map.getBounds();
      const topRight = projection.fromLatLngToPoint(bounds.getNorthEast());
      const bottomLeft = projection.fromLatLngToPoint(bounds.getSouthWest());
      const scale = Math.pow(2, this.map.getZoom());
      const worldPoint = projection.fromLatLngToPoint(this.latLng);
      this.$store.commit("SET_PIN", {
        x: Math.floor((worldPoint.x - bottomLeft.x) * scale),
        y: Math.floor((worldPoint.y - topRight.y) * scale)
      });
    }
  },

  async mounted() {
    try {
      const google = await gmapsInit();
      // const initLatlng = { lat: 38.64, lng: -121.33 };

      this.latLng = new google.maps.LatLng({lat: 38.64, lng: -121.33});

      this.map = new google.maps.Map(this.$el, {
        zoom: 7,
        center: this.latLng
      });

      // // Create the initial InfoWindow.
      // let infoWindow = new google.maps.InfoWindow({
      //   content: "Click the map to get Lat/Lng!",
      //   position: this.latLng
      // });
      // infoWindow.open(map);

      google.maps.event.addListener(this.map, "bounds_changed", () => {
        // this.$store.commit("SET_PIN", pixel(map, this.latLng));
        // console.log(pixel(map, this.latLng))
        this.setPin();
      });

      // Configure the click listener.
      google.maps.event.addListener(this.map, "click", mapsMouseEvent => {
        // Close the current InfoWindow.
        // infoWindow.close();

        // Create a new InfoWindow.
        // infoWindow = new google.maps.InfoWindow({
        //   position: mapsMouseEvent.latLng
        // });
        // console.log("event", mapsMouseEvent.pixel);
        // console.log("pixel", pixel(map, mapsMouseEvent.latLng));
        // console.log("event", mapsMouseEvent.latLng);
        this.latLng = mapsMouseEvent.latLng;
        // console.log("data", this.latLng);
        // this.$store.commit("SET_PIN", mapsMouseEvent.pixel);
        this.$store.commit("SET_LATITUDE", mapsMouseEvent.latLng.lat());
        this.$store.commit("SET_LONGITUDE", mapsMouseEvent.latLng.lng());
        this.setPin();
        // infoWindow.setContent(mapsMouseEvent.latLng.toString());
        // setTimeout(() => {
        //   infoWindow.setContent(this.$store.state.medianHouseValue);
        //   infoWindow.open(map);
        // }, 250);
      });

    } catch (error) {
      console.error(error);
    }
  }
};
</script>

<style lang="scss" scoped>
.google-map {
  width: 100%;
  height: 100vh;
}
</style>
